// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1v_FO","location":"Header_location__8vKJb"};